import '@ant-design/compatible/assets/index.css';
import { CloseOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import React from 'react';
import modal from '~components/modal';
import PartnerDetailCommissionPlanEditor from './editor';

@modal(
  {
    className: 'partner-commission-plan-editor-modal',
  },
  true,
)
class PartnerCommissionPlanEditorContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { t, editParams } = this.props;

    return (
      <div className="partner-commission-plan-editor">
        <div className="partner-commission-plan-editor__header" style={{ paddingBottom: '24px' }}>
          {t(`cms.referral.partner.detail.editor.commissionPlan.title`)}
          <CloseOutlined
            className="partner-commission-plan-editor__close-button"
            onClick={this.props.handleCloseModal}
          />
        </div>
        <PartnerDetailCommissionPlanEditor
          partnerId={editParams.partnerId}
          currentCommissionPlanId={editParams.currentCommissionId}
          partnerCountryCode={editParams.partnerCountryCode}
          onClose={this.props.handleCloseModal}
        />
      </div>
    );
  }
}

PartnerCommissionPlanEditorContainer.propTypes = {
  t: PropTypes.func.isRequired,
  editParams: PropTypes.object.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
};

PartnerCommissionPlanEditorContainer.defaultProps = {
  t: () => {},
  editParams: {},
  handleCloseModal: () => {},
};

export default PartnerCommissionPlanEditorContainer;
